import { render, staticRenderFns } from "./ListQuestion.vue?vue&type=template&id=6ff3b8b2&scoped=true&"
import script from "./ListQuestion.vue?vue&type=script&lang=js&"
export * from "./ListQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ListQuestion.vue?vue&type=style&index=0&id=6ff3b8b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff3b8b2",
  null
  
)

export default component.exports